import { dbget } from '../HOME/utils';

const baseKey = () => {
  return `NM • `;
};

export const boardKey = () => {
  return `${baseKey()}BOARD`;
};

export const statsKey = () => {
  return `${baseKey()}STATS`;
};

export const getStats = resolve => {
  const key = statsKey();

  dbget(key, stats => {
    if (!stats) {
      stats = { plays: 0, aggScore: 0, bestScore: 0 };
    }

    resolve(stats);
  });
};
